import { useState } from 'react';
import { usePagination, InterestAccountTransactionsRequest } from 'vopay';
import useFetchInterestAccountTransactions from '@/hooks/useApi/useFetchInterestAccountTransactions';

const PAGE_SIZE = 10;

export default function useTransactionSearch() {
  const {
    interestAccountTransactions: transactions,
    total,
    fetchInterestAccountTransactions,
    fetchingInterestAccountTransactions: fetching,
  } = useFetchInterestAccountTransactions();

  const { pageCount, pageIndex, setPageIndex } = usePagination(total, {
    pageSize: PAGE_SIZE,
  });

  const [req, setReq] = useState<Omit<InterestAccountTransactionsRequest, 'Limit' | 'Offset'>>({});

  async function filterTransactions(filters?: Omit<InterestAccountTransactionsRequest, 'Limit' | 'Offset'>) {
    const newReq = {
      ...filters,
      Limit: PAGE_SIZE,
      Offset: 0,
    };

    setPageIndex(0);
    setReq(newReq);

    return fetchInterestAccountTransactions(newReq);
  }

  async function changePageOffset(offset: number) {
    const newOffset = setPageIndex(offset);

    return fetchInterestAccountTransactions({
      ...req,
      Offset: newOffset,
    });
  }

  return {
    transactions,
    fetching,
    filterTransactions,
    changePageOffset,
    pageCount,
    pageIndex,
  };
}
